export const formFieldFilterFunction = (fieldName: string) =>
    !['period', 'forms'].includes(fieldName);
